module.exports = __webpack_public_path__ + "img/icon-2.e774f40b.png";